import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/shared/guards/auth.guard";
import { DashboardComponent } from "./dashboard.component";
const ɵ0 = {
    breadcrumb: "Dashboard",
};
const routes = [
    {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard],
        data: ɵ0,
    },
];
export class DashboardRoutingModule {
}
export { ɵ0 };
